/*
 * NOURION Kontaktseite: Anfrage aus dem Konfigurator vorbefuellen (Masterplan 4.4 Punkt 9, E23, B10b).
 *
 * Quelle 1: sessionStorage 'nrn-anfrage' (vollstaendiger Anfragetext). Der Eintrag wird nach der
 *           Uebernahme in das Nachrichtenfeld geloescht.
 * Quelle 2: URL Parameter ?anfrage= (Kurztext), wenn der Konfigurator sessionStorage nicht nutzen konnte.
 * Ziel:     erstes beschreibbares textarea[name="contact[body]"] (Horizon Block contact-form).
 *
 * Klassisches Skript ohne Importe und Exporte, laeuft auch als Modul (Testgeruest). Keine sichtbaren
 * Texte im Code: der Hinweis [data-nrn-anfrage-hinweis] steht im Abschnitt nrn-kontakt-daten und wird
 * nur eingeblendet. Im Theme Editor (Shopify.designMode) passiert nichts, damit der Eintrag erhalten bleibt.
 * Keine Netzwerkaufrufe, keine personenbezogenen Daten.
 */
(function nrnAnfrage() {
  'use strict';

  var SCHLUESSEL = 'nrn-anfrage';
  var PARAMETER = 'anfrage';
  var FELD = 'textarea[name="contact[body]"]';
  var HINWEIS = '[data-nrn-anfrage-hinweis]';
  var MAX_LAENGE = 20000;
  var WARTEZEIT_MS = 10000;

  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__nrnAnfrageGeladen) return;
  window.__nrnAnfrageGeladen = true;

  function designModus() {
    try {
      var s = window.Shopify;
      return Boolean(s && (s.designMode || s.visualPreviewMode));
    } catch (e) {
      return false;
    }
  }

  function ausSpeicher() {
    try {
      var speicher = window.sessionStorage;
      if (!speicher) return null;
      var wert = speicher.getItem(SCHLUESSEL);
      return typeof wert === 'string' && wert.trim() !== '' ? wert : null;
    } catch (e) {
      return null;
    }
  }

  function speicherLoeschen() {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(SCHLUESSEL);
    } catch (e) {
      /* sessionStorage gesperrt: nichts zu loeschen */
    }
  }

  function ausParameter() {
    try {
      var wert = new URLSearchParams(window.location.search).get(PARAMETER);
      return typeof wert === 'string' && wert.trim() !== '' ? wert : null;
    } catch (e) {
      return null;
    }
  }

  /** Zeilenenden vereinheitlichen, Steuerzeichen ausser Tab und Zeilenumbruch entfernen, Laenge begrenzen. */
  function bereinige(text) {
    return String(text)
      .replace(/\r\n?/g, '\n')
      .replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '')
      .slice(0, MAX_LAENGE);
  }

  function zielFeld() {
    var felder = document.querySelectorAll(FELD);
    for (var i = 0; i < felder.length; i += 1) {
      if (!felder[i].disabled && !felder[i].readOnly) return felder[i];
    }
    return null;
  }

  function hinweisZeigen() {
    var hinweise = document.querySelectorAll(HINWEIS);
    for (var i = 0; i < hinweise.length; i += 1) hinweise[i].hidden = false;
  }

  function melde(feld, typ) {
    try {
      feld.dispatchEvent(new Event(typ, { bubbles: true }));
    } catch (e) {
      /* sehr alte Browser ohne Event Konstruktor: Wert ist trotzdem gesetzt */
    }
  }

  /**
   * Uebernimmt den Text in das Nachrichtenfeld.
   * @returns {boolean} true, wenn nichts mehr zu tun ist (uebernommen oder keine Anfrage), false, wenn das Feld fehlt.
   */
  function uebernehmen() {
    var gespeichert = ausSpeicher();
    var roh = gespeichert !== null ? gespeichert : ausParameter();
    if (roh === null) return true;

    var feld = zielFeld();
    if (!feld) return false;

    var text = bereinige(roh);
    var vorhanden = String(feld.value || '').replace(/\r\n?/g, '\n');

    if (vorhanden.trim() === '') {
      feld.value = text;
    } else if (vorhanden.indexOf(text.trim()) === -1) {
      // Feld enthaelt bereits eigenen Text (zum Beispiel Formularwiederherstellung): nichts ueberschreiben, anhaengen.
      feld.value = (vorhanden.replace(/\s+$/, '') + '\n\n' + text).slice(0, MAX_LAENGE);
    }
    melde(feld, 'input');
    melde(feld, 'change');

    if (gespeichert !== null) speicherLoeschen();
    hinweisZeigen();
    return true;
  }

  /** Falls das Formular erst nach DOMContentLoaded erscheint, kurz auf das Feld warten. */
  function warteAufFeld() {
    if (typeof MutationObserver === 'undefined' || !document.documentElement) return;
    var beobachter = new MutationObserver(function () {
      if (uebernehmen()) beobachter.disconnect();
    });
    beobachter.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      beobachter.disconnect();
    }, WARTEZEIT_MS);
  }

  function start() {
    if (designModus()) return;
    if (!uebernehmen()) warteAufFeld();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
